import { render, staticRenderFns } from "./blood-oxygen-report-configuration.vue?vue&type=template&id=1b5b4f80&scoped=true"
import script from "./blood-oxygen-report-configuration.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-report-configuration.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen-report-configuration.vue?vue&type=style&index=0&id=1b5b4f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b4f80",
  null
  
)

export default component.exports